import {
  extendTheme,
  HTMLChakraProps,
  ThemingProps,
  ThemeConfig,
} from '@chakra-ui/react';

// Luego importa todo como ya lo tenías
import { CardComponent } from './additions/card/card';
import { buttonStyles } from './components/button';
import { badgeStyles } from './components/badge';
import { inputStyles } from './components/input';
import { progressStyles } from './components/progress';
import { sliderStyles } from './components/slider';
import { textareaStyles } from './components/textarea';
import { switchStyles } from './components/switch';
import { linkStyles } from './components/link';
import { accordionStyles } from './components/accordion';
import { FormErrorMessage } from './components/form';
import { breakpoints } from './foundations/breakpoints';
import { globalStyles } from './styles';

// Agrega esta configuración justo aquí
const config: ThemeConfig = {
  initialColorMode: 'dark', // 🌙 Establece dark como predeterminado
  useSystemColorMode: false, // 🚫 Ignora la preferencia del sistema
};

// Aquí inyectas la configuración en el theme extendido
let theme = extendTheme(
  {
    config,
    breakpoints,
  },
  globalStyles,
  badgeStyles,
  buttonStyles,
  linkStyles,
  progressStyles,
  sliderStyles,
  inputStyles,
  textareaStyles,
  switchStyles,
  accordionStyles,
  {
    components: {
      FormErrorMessage,
    },
  },
  CardComponent,
);

export default theme;

export interface CustomCardProps extends HTMLChakraProps<'div'>, ThemingProps {}